"use strict";
/**
 * Pure helpers for the Personas admin view.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatePersonasCategoryId = exports.arePersonasSchemasEqual = exports.clonePersonasSchema = void 0;
exports.clonePersonasSchema = function (schema) {
    return schema.map(function (category) { return (__assign(__assign({}, category), { properties: category.properties.map(function (property) { return (__assign(__assign({}, property), { useCases: property.useCases.map(function (useCase) { return (__assign({}, useCase)); }) })); }) })); });
};
exports.arePersonasSchemasEqual = function (left, right) {
    return JSON.stringify(left) === JSON.stringify(right);
};
exports.generatePersonasCategoryId = function (existing) {
    var base = 'group';
    var used = new Set(existing.map(function (category) { return category.id; }));
    var index = existing.length + 1;
    var candidate = base + "-" + index;
    while (used.has(candidate)) {
        index += 1;
        candidate = base + "-" + index;
    }
    return candidate;
};
